import { createContext } from 'react';
import { InternalSiloRealFormContext } from './form-provider';

type SiloRealFormContextType = ReturnType<typeof InternalSiloRealFormContext> | undefined;
export const SiloRealFormContext = createContext<SiloRealFormContextType>(undefined);
